import clsx from "clsx"
import { useSession } from "components/auth/useSession"
import dayjs from "dayjs"
import ReplyIcon from "/icons/reply.svg?raw"
import ThumbsUpIcon from "/icons/thumbsUp.svg?raw"
import { useState } from "react"
import toast from "react-hot-toast"
import useSWRMutation from "swr/mutation"
import Comment from "./comment"
import styles from "./comment.module.scss"
import Form from "./form"
import commentStyles from './index.module.scss'

const vote = (url: string, { arg }: { arg: "likes" | "dislikes" }) => fetch(`${url}/${arg}`, { method: "POST" }).then(r => r.json())

type Props = PostComment & {
    comment_post_ID: string
    onSignIn: () => void
    isMobileApp?: boolean
}

export default function Component({ onSignIn, comment_post_ID, comment_ID, comment_author_avatar, comment_author, comment_date, comment_content, likes, dislikes, replies, isAnonymous, isMobileApp }: Props) {
    const { data: session } = useSession()
    const [showForm, setShowForm] = useState(false)

    const votedComments = getVotedComments()
    const isVoted = votedComments.includes(comment_ID)

    const { data, trigger, isMutating } = useSWRMutation(`/api/me/comments/${comment_ID}`, vote, {
        onSuccess: () => {
            votedComments.push(comment_ID)
            while (votedComments.length > 50) {
                votedComments.shift();
            }
            setVotedComments(votedComments)
        },
    })

    return (
        <div className={clsx(styles.comment, commentStyles.commentsFrm)}>
            <div className={styles.user}>
                {comment_author_avatar && !isAnonymous
                    ? <img src={comment_author_avatar} alt={comment_author} width={40} height={40} referrerPolicy="no-referrer" />
                    : <i className="svgIcon"><svg><use xlinkHref="#IconUser"></use></svg></i>
                }

                <div className={styles.name} dangerouslySetInnerHTML={{ __html: comment_author }} />

                <time>{dayjs(comment_date).format("DD·MM·YYYY HH:mm")}</time>
            </div>

            <div className={styles.content}>{comment_content}</div>
            <div className={styles.actions}>
                <button className={clsx(styles.reply, styles.left)} onClick={() => setShowForm(!showForm)}>
                    <div dangerouslySetInnerHTML={{ __html: ReplyIcon }} />
                    Απαντήστε
                </button>
                {!isMobileApp && <div className={styles.right}>
                    <button
                        className={styles.upvote}
                        disabled={isMutating}
                        onClick={() => {
                            if (isVoted) {
                                toast("Έχετε ήδη ψηφίσει αυτό το σχόλιο.")
                                return
                            }

                            if (!session) {
                                onSignIn()
                                return
                            }

                            trigger("likes", { optimisticData: { meta_key: "posVotes", meta_value: String(likes + 1) } })
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: ThumbsUpIcon }} />
                        {data?.meta_key == "posVotes" ? data.meta_value : likes}
                    </button>
                    <button
                        className={styles.downvote}
                        disabled={isMutating}
                        onClick={() => {
                            if (isVoted) {
                                toast("Έχετε ήδη ψηφίσει αυτό το σχόλιο.")
                                return
                            }

                            if (!session) {
                                onSignIn()
                                return
                            }

                            trigger("dislikes", { optimisticData: { meta_key: "negVotes", meta_value: String(dislikes + 1) } })
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: ThumbsUpIcon }} />
                        {data?.meta_key == "negVotes" ? data.meta_value : dislikes}
                    </button>
                </div>}
            </div>

            {showForm && !isMobileApp && <Form comment_post_ID={Number(comment_post_ID)} comment_parent={Number(comment_ID)} onSignIn={onSignIn} />}

            {replies.map(D => <Comment key={D.comment_ID} onSignIn={onSignIn} comment_post_ID={comment_post_ID} {...D} />)}
        </div >
    )
}

function getVotedComments() {
    try {
        const voted = localStorage.getItem("voted")
        return voted ? JSON.parse(voted) : []
    } catch (e) {
        return []
    }
}

function setVotedComments(ids: number[]) {
    try {
        localStorage.setItem("voted", JSON.stringify(ids))
    } catch (e) {
    }
}